/* eslint-disable camelcase */
export default {
	actionsButton: "Actions",
	transcribeButton: "Transcribe Recording",
	meetingAssistantButton: "Add meeting assistant",
	meetingAssistantSaveButton: "Save",
	meetingAssistantCancelButton: "Cancel",

	editNoteNameMenuItem: "Edit note name",
	editDateAndTimeMenuItem: "Edit date & time",
	saveAsTemplateMenuItem: "Save as template",
	copyLinkToNoteMenuItem: "Copy link to note",
	deleteNoteMenuItem: "Delete note",
	transcribeMenuItem: "Transcribe from recording",
	addAssistantMenuItem: "Add Teaming Assistant",
	scheduleRecurrenceMenuItem: "Repeat this meeting",
};
